import { createContext, FC } from 'react'
import { useReducerGeneric } from '../../generic-reducer/use-reducer-generic'

type TenantIdAndPropertyIdContext = {
  tenantId: string,
  propertyId: string,
  tenantIdAndPropertyIdSubstitute: (path: string, part: unknown) => void
}

const TenantIdAndPropertyIdDefaultValue = {
  tenantId: '',
  propertyId: '',
}

type TenantIdAndPropertyIdState = typeof TenantIdAndPropertyIdDefaultValue

export const TenantIdAndPropertyIdContext = createContext({ ...TenantIdAndPropertyIdDefaultValue } as TenantIdAndPropertyIdContext)

export const TenantIdAndPropertyIdProvider: FC = ({ children }) => {
  const [TenantIdAndPropertyId, tenantIdAndPropertyIdSubstitute] = useReducerGeneric<TenantIdAndPropertyIdState>({
    initial_state_params: TenantIdAndPropertyIdDefaultValue,
  })

  return <TenantIdAndPropertyIdContext.Provider value={{ ...TenantIdAndPropertyId, tenantIdAndPropertyIdSubstitute }}>{children}</TenantIdAndPropertyIdContext.Provider>
}
